import { type SentryWithModuleMetaData } from './SentryWithModuleMetaData';

const stackTraceFrameHasModuleMetaData = function (
    frame: SentryWithModuleMetaData,
): frame is SentryWithModuleMetaData & Required<SentryWithModuleMetaData['module_metadata']> {
    return Boolean(frame.module_metadata?.name);
};

export { stackTraceFrameHasModuleMetaData };
